import { holdsTier } from '@shared/auth/capabilities';
import { useSessionStore } from '@shared/auth/session';

import { SERVICE_SECTIONS, type ServiceSectionSpec } from './services';

/**
 * The sections this account may actually open.
 *
 * **Nine is the maximum, not the count.** A configuration table is an `admin`
 * right in the service that owns it, so the console offers the services this
 * account administers and leaves out the rest — an operator meeting nine `403`
 * banners learned nothing about a surface that was never theirs.
 *
 * It is read from the session store rather than from a probe, so the index
 * fetches nothing at all: the old single page fired nine parallel reads on
 * arrival to draw tables the operator had not asked for.
 */
export function useAdministeredSections(): readonly ServiceSectionSpec[] {
  const capabilities = useSessionStore((state) => state.capabilities);

  return SERVICE_SECTIONS.filter((spec) => holdsTier(capabilities, spec.key, 'admin'));
}
